/*
 * TEMPORARILY DISABLED
 * Business decision: RTC (Request Callback) feature is paused while project is on hold.
 * Re-enable by setting this flag to true when RTC initiative resumes.
 */
export const RTC_UI_ENABLED = false;
